import React from "react"
import "react-web-tabs/dist/react-web-tabs.css"
import { Row } from "reactstrap"
import firebase from "firebase/app"
import IndexNavbar from "components/Navbars/IndexNavbar.js"
import Footer from "components/Footers/Footer.js"
import "./styles.css"
import NotificationAlert from "react-notification-alert"
import SettingsTab from "components/CustomerSettings/SettingsTab"

class MyAccount extends React.Component {
  state = {
    activeTab: "1",
  }

  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      })
    }
  }

  notify = (type, message, title) => {
    let options = {
      place: "tc",
      message: (
        <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {" "}
            {title}
          </span>
          <span data-notify="message">{message}</span>
        </div>
      ),
      type: type,
      icon: "ni ni-bell-55",
      autoDismiss: 5,
    }
    this.refs.notificationAlert.notificationAlert(options)
  }

  // startDataListeners = () => {
  //   /**
  //    * Get all payment methods for the logged in customer
  //    */

  //   firebase
  //     .firestore()
  //     .collection("stripe_customers")
  //     .doc(currentUser.uid)
  //     .collection("payment_methods")
  //     .onSnapshot((snapshot) => {
  //       if (snapshot.empty) {
  //         // document.querySelector("#add-new-card").open = true
  //       }
  //       snapshot.forEach(function (doc) {
  //         const paymentMethod = doc.data()
  //         if (!paymentMethod.card) {
  //           console.log("HERE")
  //           return
  //         }

  //         console.log("[PAYMENT METHOD]", paymentMethod)

  //         const optionId = `card-${doc.id}`
  //         let optionElement = document.getElementById(optionId)

  //         // Add a new option if one doesn't exist yet.
  //         if (!optionElement) {
  //           optionElement = document.createElement("option")
  //           optionElement.id = optionId
  //           document
  //             .querySelector("select[name=payment-method]")
  //             .appendChild(optionElement)
  //         }

  //         optionElement.value = paymentMethod.id
  //         optionElement.text = `${paymentMethod.card.brand} •••• ${paymentMethod.card.last4} | Expires ${paymentMethod.card.exp_month}/${paymentMethod.card.exp_year}`
  //       })
  //     })

  //   /**
  //    * Get all payments for the logged in customer
  //    */
  //   firebase
  //     .firestore()
  //     .collection("stripe_customers")
  //     .doc(currentUser.uid)
  //     .collection("payments")
  //     .onSnapshot((snapshot) => {
  //       snapshot.forEach((doc) => {
  //         const payment = doc.data()

  //         // let liElement = document.getElementById(`payment-${doc.id}`);
  //         // if (!liElement) {
  //         //   liElement = document.createElement('li');
  //         //   liElement.id = `payment-${doc.id}`;
  //         // }

  //         // let content = '';
  //         if (
  //           payment.status === "new" ||
  //           payment.status === "requires_confirmation"
  //         ) {
  //           // content = `Creating Payment for ${formatAmount(
  //           //   payment.amount,
  //           //   payment.currency
  //           // )}`;
  //         } else if (payment.status === "succeeded") {
  //           // const card = payment.charges.data[0].payment_method_details.card;
  //           // content = `✅ Payment for ${formatAmount(
  //           //   payment.amount,
  //           //   payment.currency
  //           // )} on ${card.brand} card •••• ${card.last4}.`;
  //         } else if (payment.status === "requires_action") {
  //           // content = `🚨 Payment for ${formatAmount(
  //           //   payment.amount,
  //           //   payment.currency
  //           // )} ${payment.status}`;
  //           // handleCardAction(payment, doc.id);
  //         } else {
  //           // content = `⚠️ Payment for ${formatAmount(
  //           //   payment.amount,
  //           //   payment.currency
  //           // )} ${payment.status}`;
  //         }
  //         // liElement.innerText = content;
  //         // document.querySelector('#payments-list').appendChild(liElement);
  //       })
  //     })
  // }

  // authListener() {
  //   this.fireBaseListener = firebase
  //     .auth()
  //     .onAuthStateChanged((firebaseUser) => {
  //       if (firebaseUser) {
  //         currentUser = firebaseUser
  //         firebase
  //           .firestore()
  //           .collection("stripe_customers")
  //           .doc(currentUser.uid)
  //           .onSnapshot((snapshot) => {
  //             if (snapshot.data()) {
  //               this.setState({ customerData: snapshot.data(), loading: false })
  //               this.startDataListeners()

  //               // document.getElementById("loader").style.display = "none"
  //               // document.getElementById("content").style.display = "block"
  //             } else {
  //               this.setState({ loading: false })
  //               console.warn(
  //                 `No Stripe customer found in Firestore for user: ${currentUser.uid}`
  //               )
  //             }
  //           })
  //       } else {
  //         // document.getElementById("content").style.display = "none"
  //         // firebaseUI.start("#firebaseui-auth-container", firebaseUiConfig)
  //       }
  //     })
  // }

  // componentWillMount() {
  //   this.authListener = this.authListener.bind(this)
  //   this.setState({ loading: true })
  //   this.authListener()
  // }

  // componentWillUnmount() {
  //   this.fireBaseListener && this.fireBaseListener()
  //   this.authListener = undefined
  // }

  // componentDidMount() {
  //   console.log("user", user)
  // }

  render() {
    return (
      <div>
        <IndexNavbar />
        <div className="main-content" style={{ padding: "20px 100px" }}>
          <div className="rna-wrapper">
            <NotificationAlert ref="notificationAlert" />
          </div>
          <h1>Account Settings</h1>
          <h4>Change your profile and account settings</h4>
          <Row
            className="mt-5"
            style={{
              backgroundColor: "white",
              padding: "50px 0px",
            }}
          >
            <SettingsTab notify={this.notify} state={this.state} />
          </Row>
        </div>
        <Footer />
      </div>
    )
  }
}

export default MyAccount
